module.exports = __webpack_public_path__ + "img/active-layer8.289dad37.png";